
import { defineComponent, PropType, ref } from 'vue';
import { Document, Loading, Close, Check } from '@element-plus/icons-vue';
import useFileList from './hooks/use-file-list';
import type { IFileData } from './types';

export default defineComponent({
  name: 'TextFileList',
  components: {
    [Document.name]: Document,
    [Loading.name]: Loading,
    [Close.name]: Close,
    [Check.name]: Check,
  },
  props: {
    list: {
      type: Array as PropType<IFileData[]>,
      default: () => ([]),
    },
  },
  setup(props) {
    const activeIndex = ref<null | number>(null);
    const {
      handleDel,
    } = useFileList(props);

    return {
      handleDel,
      activeIndex,
    };
  },
  render() {
    const iconRender = (item: IFileData, i: number) => {
      if (item.loading) {
        return (<el-icon color="#409eff">
            <loading />
          </el-icon>);
      }

      if (this.activeIndex === i) {
        // return (<i class="el-icon-close" onClick={() => this.handleDel(i, item)}></i>);
        return (
          <el-icon onClick={() => this.handleDel(i, item)}>
            <close />
          </el-icon>
        );
      }
      // return (<i class="el-icon-check"></i>);
      return (
        <el-icon color="#67c23a">
          <check />
        </el-icon>
      );
    };

    return (
      <ul>
        {
          this.$props.list.map((item, i) => {
            return (
              <li
                class="text-file__list"
                key={i}
                onMouseenter={() => {
                  this.activeIndex = i;
                }}
                onMouseleave={() => {
                  this.activeIndex = null;
                }}
              >
                <div class="text-file__list--name">
                  <el-icon color="#909399" class="icon-document">
                    <document />
                  </el-icon>
                  {item.name || item.url}
                </div>
                <div class="text-file__list--label">
                  {
                    iconRender(item, i)
                  }
                </div>
              </li>
            );
          })
        }
      </ul>
    );
  },
});
